import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Node } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import { addRootClasses, removeRootClasses } from '../../../../store/actions/UI';

import Button from '../../../../components/Button';

import './style.scss';

const NewsOverview = ({ onLoadMore, entities, pager }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Hide shape at bottom of page.
  useEffect(() => {
    dispatch(addRootClasses('hide-shape'));
    return () => dispatch(removeRootClasses('hide-shape'));
  }, [dispatch]);

  return (
    <div className="NewsOverview">
      <div className="row">
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <Node
              id={id}
              key={`${uuid}:${langcode}`}
              entity={entity}
              viewMode="teaser"
              className="col-12 col-md-4 p-3"
            />
          );
        })}
      </div>
      <Button secondary iconDown onClick={() => onLoadMore()}>
        {t('buttons.loadMore')}
      </Button>
    </div>
  );
};

export default NewsOverview;
